<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="宣讲会内容" name="first"></el-tab-pane>
      <el-tab-pane label="企业简介" name="second"></el-tab-pane>
      <el-tab-pane label="报名学生列表" name="students"></el-tab-pane>
    </el-tabs>

    <div v-show="activeName == 'first' || activeName == 'second'">
      <el-form ref="form" :model="EditItem" label-width="120px">
        <el-form-item label="宣讲会时间">
          <el-input v-model="EditItem.xjh_date" style="width:600px" placeholder="请输入宣讲会开始和结束时间"></el-input>
        </el-form-item>
        <el-form-item label="宣讲会地址">
          <el-input v-model="EditItem.xjh_address" style="width:600px" placeholder="请输入宣讲会地址"></el-input>
        </el-form-item>
      </el-form>
    </div>

    <div style="max-width: 1000px" v-show="activeName == 'first' || activeName == 'second'">
      <UEditor ref="ue" @ready="editorReady" style="width: 100%"></UEditor>
    </div>

    <div style="max-width: 1000px; padding: 20px; text-align: right"
      v-show="activeName == 'first' || activeName == 'second'">
      <el-button icon="el-icon-check" style="margin-left: 10px" type="primary" @click="saveFrom()">保存</el-button>

      <el-button icon="el-icon-view" style="margin-left: 10px" type="primary" @click="viewForm()">预览</el-button>
    </div>


    <div v-if="activeName == 'students'" class="recommendPage">

      <div class="flex_1" style="width:100%;overflow-y:auto;padding:0 15px">
        <ul class="list-items">


          <li class="list-item flexCenter" v-for="(p, idx) in tableData" :key="idx">

            <div class="list-item-meta flexStart flex_1">
              <div class="list-item-meta-avatar">
                <span class="avatar-image flexCenter">
                  <el-image fit="cover" style="width:100%;height:100%;" :src="p.photo ? p.photo : url"></el-image>
                </span>
                <div class="avatarBadgeContainer flexCenter">
                  <img v-if="p.sex == 1" style="width:100%;height:100%;" src="../../../public/img/male.png" alt="">
                  <img v-if="p.sex == 2" style="width:100%;height:100%;" src="../../../public/img/female.png" alt="">
                </div>

              </div>
              <div class="list-item-meta-content">
                <h4 class="list-item-meta-title">
                  <a class="felxStart" href="javascript:;">{{ p.stu_name }}
                    <span v-if="p.job_arr && p.job_arr.length > 0" v-for="(job, idx_job) in p.job_arr"
                      style="margin: 0 8px; font-size: 14px;">
                      {{ job.job_type_name }}</span>
                  </a>
                </h4>
                <div class="list-item-meta-description">
                  <div class="flexStart">
                    <span>薪资:{{ p.pay == 0 ? '面议' : (xzfw[p.pay] || "-") }}</span>
                    <el-divider direction="vertical" />
                    <span>城市:{{ p.cityName || '-' }}</span>
                    <el-divider direction="vertical" />
                    <span>学历:{{ xlyq[p.eduaction] || "-" }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="list-content">
              <div class="list-content-item">
                <p>{{ p.create_date.split(" ")[0] }} 发布</p>
              </div>
            </div>
            <ul class="list-item-action felxCloumn">
              <li>
                <div class="flexCenter">
                  <el-tag v-if="p.invite_status == 0" size="mini" @click.stop="xiangqing(p)" type="primary"
                    style="cursor:pointer;">查看</el-tag>
                  <el-tag v-if="p.invite_status == 1" size="mini" @click.stop="xiangqing(p)" type="primary"
                    style="cursor:pointer;" plain>查看</el-tag>
                </div>
              </li>

            </ul>
          </li>
        </ul>
      </div>
      <el-pagination @current-change="handlePageChange" @size-change="handleSizeChange" :current-page="page.current_page"
        :page-size="page.per_page" :total="page.count" layout="total, sizes,prev, pager, next"
        :page-sizes="[10, 20, 50, 100]" style="margin: 10px 0 0 15px;">
      </el-pagination>

      <Detail v-if="dialogForm" pages="xjh" :formData="formData" :xlyq="xlyq" :xzfw="xzfw" :qzzt="qzzt" @touch="chakan">
      </Detail>

    </div>





  </div>
</template>

<script>
import UEditor from "./com/ueditor.vue";
import citys from "../../utils/arae_value.js";
import Detail from "./com/resumeDetail.vue";
import aes from '../../utils/aes.js'

export default {
  name: "companInfo",
  components: {
    UEditor, Detail
  },
  data() {
    return {
      editor: null,
      activeName: "first",
      EditItem: {
        html_content: "",
        enter_desc: "",
        xjh_date: "",
        xjh_address: ""
      },
      formData: {},
      tableData: [],
      tdzt: {},
      mszt: {},
      lyzt: {},
      xlyq: {},
      xzfw: {},
      qzzt: {},
      yqzt: {},
      options: [],
      dialogForm: false,
      url: "./img/img_avatar.png",
      page: {
        count: 0,
        current_page: 1,
        per_page: 20,
        total_page: 0
      },
    };
  },
  mounted() {
    this.getComType()
    this.getData();
  },
  methods: {
    getComType() {
      return new Promise(resolve => {
        this.$http
          .post("/api/sys_param_list", {
            param_type:
              "'TDZT','LYZT','MSZT','EDUACTION','SALARY_RANGE','QZZT','YQZT'",
            used: 0
          })
          .then(res => {
            let tdzt = {}; //投递状态
            let mszt = {}; //面试状态
            let lyzt = {}; //录用状态
            let xzfw = {}; //薪资类型
            let xlyq = {}; //学历类型
            let qzzt = {}; //求职状态
            let yqzt = {}; //邀请状态
            for (let item of res.data) {
              if (item.param_type == "TDZT") {
                tdzt[item.param_value] = item.param_desc;
              }
              if (item.param_type == "SALARY_RANGE") {

                xzfw[item.param_value] = item.param_desc;
              }
              if (item.param_type == "EDUACTION") {

                xlyq[item.param_value] = item.param_desc;
              }
              if (item.param_type == "MSZT") {

                mszt[item.param_value] = item.param_desc;
              }
              if (item.param_type == "LYZT") {

                lyzt[item.param_value] = item.param_desc;
              }
              if (item.param_type == "QZZT") {

                qzzt[item.param_value] = item.param_desc;
              }
              if (item.param_type == "YQZT") {

                yqzt[item.param_value] = item.param_desc;
              }
            }
            this.tdzt = tdzt;
            this.mszt = mszt;
            this.lyzt = lyzt;
            this.xzfw = xzfw;
            this.xlyq = xlyq;
            this.qzzt = qzzt;
            this.yqzt = yqzt;
            resolve();
          });
      });
    },
    getData() {
      this.$http.post("/api/zp_xjh_info").then((res) => {
        if (res.data) {
          this.EditItem = res.data;
          if (this.editor) {
            if (this.activeName == "first") {
              this.editor.setContent(this.EditItem.html_content);
            } else if (this.activeName == "second") {
              this.editor.setContent(this.EditItem.enter_desc);
            }
          }
        }
      });
    },
    editorReady(editorInstance) {
      if (this.EditItem) {
        editorInstance.setContent(this.EditItem.html_content);
      }

      this.editor = editorInstance;
    },
    handleClick() {
      if (this.activeName == "second") {
        this.EditItem.html_content = this.editor.getContent();
        this.editor.setContent(this.EditItem.enter_desc);
      } else if (this.activeName == "first") {
        this.EditItem.enter_desc = this.editor.getContent();
        this.editor.setContent(this.EditItem.html_content);
      } else if (this.activeName == "students") {

        this.getJoinList()
      }
    },
    saveFrom() {
      if (this.activeName == "first") {
        this.EditItem.html_content = this.editor.getContent();
      } else if (this.activeName == "second") {
        this.EditItem.enter_desc = this.editor.getContent();
      }
      this.$http.post("/api/zp_xjh_save", this.EditItem).then((res) => {
        this.$message.success("保存成功！");
        this.getData();
      });
    },
    viewForm() {
      window.open("./#/qyxjh/" + this.EditItem.enter_id);
    },
    getJoinList() {

      let data = {};
      data.xjh_id = this.EditItem.id
      data.page = this.page.current_page;
      data.pagesize = this.page.per_page;
      this.$http.post("/api/zp_xjhjoin_list", data).then(res => {

        if (res.data && res.data.data) {
          res.data.data.map(a => {
            let obj = this.getParentId(citys, a.city);
            a.cityName = obj ? obj.label : '';
          });
          this.tableData = res.data.data;
        }
        this.page = res.data.page;


      });
    },
    getParentId(list, iid) {
      if (list && list.length > 0) {
        for (let o of list) {
          if (o.value == iid) return o;
          const o_ = this.getParentId(o.children, iid);
          if (o_) return o_;
        }
      }
    },

    canParseToJson(str, parseFlag) {
      try {
        if (typeof JSON.parse(str) === "object" && ((Object.prototype.toString.call(JSON.parse(str)) === "[object Object]") ||
          (Object.prototype.toString.call(JSON.parse(str)) === "[object Array]"))) {
          return parseFlag === true ? JSON.parse(str) : true
        }
      } catch (e) { }
      return false
    },
    handlePageChange(page) {
      this.page.current_page = page;
      this.getJoinList();
    },
    handleSizeChange(val) {
      this.page.current_page = 1;
      this.page.per_page = val;
      this.getJoinList(1)
    },
    xiangqing(row) {
      let _this = this
      this.$http.post("/api/zp_resume_info", { id: row.stu_id }).then(res => {
        // this.$http.post("/api/zp_resume_info", { id: 5003 }).then(res => {
        let beforedata = res.data
        let result = res.data
        // beforedata = aes.decrypt(beforedata).then(result => {
          if (result && _this.isJSON(result)) {
            let finalData = JSON.parse(result)
            // console.log(210, finalData)
            if (finalData) {
              res.data = finalData

              if (!res.data.tel) {
                res.data.tel = '***********'
              } else {
                res.data.tel = '***********'
              }

              if (!res.data.wechat) {
                res.data.wechat = '***********'
              } else {
                res.data.wechat = '***********'

              }

              if (res.data.award_annex && this.canParseToJson(res.data.award_annex)) {
                res.data.award_annex = JSON.parse(res.data.award_annex)
              }
              if (res.data.job_array) {
                res.data.job_array.map(a => {
                  let obj = this.getParentId(citys, a.city);
                  a.cityName = obj ? obj.label : '';
                });
              }
              if (res.data.practice && this.canParseToJson(res.data.practice)) {
                res.data.practice = JSON.parse(res.data.practice)
              }
              if (res.data.project && this.canParseToJson(res.data.project)) {
                res.data.project = JSON.parse(res.data.project)
                res.data.project.map(a => {
                  if (a.annex && this.canParseToJson(a.annex)) {
                    a.annex = JSON.parse(a.annex)
                  }
                })
              }
              this.formData = res.data;
              this.dialogForm = true;

            }
          }
        // })
      });
    },

    chakan(row) {
      if (!this.job_id) {
        this.$message({
          type: "error",
          message: "请先选择职位!"
        });
        return false;
      }
      this.$http
        .post("/api/zp_gwyq_edit", {
          job_id: this.job_id,
          resume_id: row.id
        })
        .then(res => {
          this.$message({
            type: "success",
            message: `职位邀请成功!`
          });
          this.dialogForm = false
          this.getList();
        });
    }

  },
};
</script>

<style scoped lang="less">
.pageContainer {
  /deep/ .box-card {
    margin-bottom: 12px;
    padding: 24px 10px 24px 30px;
  }

  /deep/ .el-card__body {
    padding: 0px;
  }

}

.recommendPage {

  ul,
  li {
    list-style: none;

    outline: none;
  }

  .list-items {
    width: 100%;
    margin: 5px 0 0 0;
    padding: 0;
    list-style: none;

    outline: none;

    .list-item {

      background-color: #fff;
      padding: 24px !important;
      border: 0;
      margin-bottom: 12px;
      outline: none;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);

      .list-item-meta {
        align-items: center;

        .list-item-meta-avatar {
          position: relative;
          margin-right: 16px;

          span {
            width: 52px;
            height: 52px;
            line-height: 52px;
            border-radius: 50%;
            margin: 0;
            padding: 0;
            font-size: 14px;
            font-variant: tabular-nums;
            list-style: none;
            font-feature-settings: 'tnum';
            position: relative;
            display: inline-block;
            overflow: hidden;
            color: #fff;
            white-space: nowrap;
            text-align: center;
            vertical-align: middle;
          }

          .avatarBadgeContainer {
            position: absolute;
            top: 0;
            right: 0;
            width: 14px;
            height: 14px;
            border-radius: 50%;
            /* border: 1px solid #fff; */
            overflow: hidden;
            background-color: #fff;
          }
        }

        .list-item-meta-content {
          -webkit-box-flex: 1;
          flex: 1 0;

          .list-item-meta-title {
            font-size: 18px;
            margin-top: 0;
            margin-bottom: 17px;
            color: #000000a6;
            line-height: 22px;
            font-weight: 500;

            a {
              font-size: 18px;
              color: #000000a6;
              -webkit-transition: all 0.3s;
              transition: all 0.3s;
              touch-action: manipulation;
              background-color: transparent;
              cursor: pointer;
              text-decoration: none;
              outline: none;
            }
          }

          .list-item-meta-description {
            color: rgba(0, 0, 0, 0.45);
            font-size: 14px;
            line-height: 22px;

            span {
              font-size: 14px;
              color: rgb(48, 49, 51);
            }
          }
        }

      }

      .list-content {
        .list-content-item {
          color: rgba(0, 0, 0, 0.45);
          display: inline-block;
          vertical-align: middle;
          font-size: 14px;
          margin-left: 40px;

          p {
            margin-top: 4px;
            margin-bottom: 0;
            line-height: 22px;
          }
        }
      }

      .list-item-action {
        flex: 0 0 auto;
        margin-left: 48px;
        padding: 0;
        font-size: 0;
        list-style: none;
      }
    }
  }

  .cus_dialog {

    div {
      box-sizing: border-box;
    }

    .rowContainer {
      width: 100%;

      .item-userinfo {
        margin-top: 32px;

        .color30 {
          color: #303133;
        }

        .color60 {
          color: #606266;
        }

        .fontWeight500 {
          font-weight: 700;
        }

        .left {
          width: 100px;
        }

        .right {
          margin-left: 32px;

          .userName {
            font-size: 18px;
            color: #303133;
            font-weight: 500;
            margin-right: 4px;
          }

          .contact {
            margin-top: 8px;
          }

          .timestamp {
            color: #909399;
            font-size: 12px;
          }

          .commonText {
            margin-top: 8px;
          }

          .annexResume {
            margin-top: 8px;
            color: #3378fa;
            cursor: pointer;
          }

          .item-att {
            margin-left: 8px;
            color: #3378fa;
            cursor: pointer;
          }
        }
      }

      .item-userinfo:first-of-type {
        margin-top: 0;
      }

      .subitem-userinfo {
        margin-top: 16px;
        color: #606266;
      }

      .crumbImg {
        width: 100%;

        .thumbnail {
          display: inline-block;
          width: 20%;

          img {
            display: inline-block;
            width: 100%;
          }
        }
      }
    }

    .avatarContainer {
      flex: 0 1 68px;

      &>span {
        border-radius: 68px;
        display: block;
        width: 68px;
        height: 68px;
        line-height: 68px;
      }

      .ant-avatar.ant-avatar-icon {
        font-size: 40px;
      }

      img {
        display: inline-block;
        width: 68px;
        height: 68px;
        border-radius: 50%;
      }
    }

    .right {
      .ant-divider-vertical {
        margin: 0 16px;
      }
    }



  }
}
</style>
